export default __webpack_public_path__ + "images/c6a1ea0692afa735e4ffeb7008bfe74a-buildBuzz.webp";